import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { FINANCE, LEASE } from '@makemydeal/dr-platform-types';

/**
 * Returns the appropriate selector for total amount due based on the offer type
 * @param state - The Redux state
 * @returns A selector function that returns the total amount due based on offer type:
 *   - FINANCE: returns amount financed
 *   - LEASE: returns total amount due for lease
 *   - Other (CASH): returns cash amount due after credits (gross). When PS handles
 *     `holdDeposit` math, the value returned by this selector is already net of
 *     Cash Down on the read path, so MV must not subtract again.
 */

export const getTotalAmountDueSelector = (state: any) => {
    const offerType = offerReduxSelectors.getCurrentOfferType(state);

    if (offerType === FINANCE) {
        return offerSelectors.getAmountFinanced;
    } else if (offerType === LEASE) {
        return offerReduxSelectors.getTotalAmountDue;
    } else {
        return offerReduxSelectors.getCashTotalAmountDueAfterCredits;
    }
};
